// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"632":"6ee8040e","856":"25d3fb7d"}[chunkId] + ".chunk.css";
};